import {
  useMutation
} from '@tanstack/vue-query'
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query'
import {
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  BackendErrorEntity,
  OrderEntity,
  PlaceOrderItemAsAdminBodyDto,
  PlaceOrderItemsBodyDto,
  ResendOrderEmailsBodyDto,
  ResendOrderEmailsResponseDto
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType, BodyType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiPlaceOrderItems = (
    orderId: MaybeRef<string | undefined | null>,
    placeOrderItemsBodyDto: MaybeRef<PlaceOrderItemsBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      orderId = unref(orderId);
placeOrderItemsBodyDto = unref(placeOrderItemsBodyDto);
      
      return fetchApiInstance<OrderEntity>(
      {url: `/orders/${orderId}/placeOrderItems`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: placeOrderItemsBodyDto
    },
      options);
    }
  


export const getApiPlaceOrderItemsMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiPlaceOrderItems>>, TError,{orderId: string;data: BodyType<PlaceOrderItemsBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiPlaceOrderItems>>, TError,{orderId: string;data: BodyType<PlaceOrderItemsBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiPlaceOrderItems>>, {orderId: string;data: BodyType<PlaceOrderItemsBodyDto>}> = (props) => {
          const {orderId,data} = props ?? {};

          return  apiPlaceOrderItems(orderId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiPlaceOrderItemsMutationResult = NonNullable<Awaited<ReturnType<typeof apiPlaceOrderItems>>>
    export type ApiPlaceOrderItemsMutationBody = BodyType<PlaceOrderItemsBodyDto>
    export type ApiPlaceOrderItemsMutationError = ErrorType<BackendErrorEntity>

    export const useApiPlaceOrderItems = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiPlaceOrderItems>>, TError,{orderId: string;data: BodyType<PlaceOrderItemsBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiPlaceOrderItems>>,
        TError,
        {orderId: string;data: BodyType<PlaceOrderItemsBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiPlaceOrderItemsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiPlaceOrderItemAsAdmin = (
    orderId: MaybeRef<string | undefined | null>,
    placeOrderItemAsAdminBodyDto: MaybeRef<PlaceOrderItemAsAdminBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      orderId = unref(orderId);
placeOrderItemAsAdminBodyDto = unref(placeOrderItemAsAdminBodyDto);
      
      return fetchApiInstance<OrderEntity>(
      {url: `/orders/${orderId}/placeOrderItemAsAdmin`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: placeOrderItemAsAdminBodyDto
    },
      options);
    }
  


export const getApiPlaceOrderItemAsAdminMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiPlaceOrderItemAsAdmin>>, TError,{orderId: string;data: BodyType<PlaceOrderItemAsAdminBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiPlaceOrderItemAsAdmin>>, TError,{orderId: string;data: BodyType<PlaceOrderItemAsAdminBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiPlaceOrderItemAsAdmin>>, {orderId: string;data: BodyType<PlaceOrderItemAsAdminBodyDto>}> = (props) => {
          const {orderId,data} = props ?? {};

          return  apiPlaceOrderItemAsAdmin(orderId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiPlaceOrderItemAsAdminMutationResult = NonNullable<Awaited<ReturnType<typeof apiPlaceOrderItemAsAdmin>>>
    export type ApiPlaceOrderItemAsAdminMutationBody = BodyType<PlaceOrderItemAsAdminBodyDto>
    export type ApiPlaceOrderItemAsAdminMutationError = ErrorType<BackendErrorEntity>

    export const useApiPlaceOrderItemAsAdmin = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiPlaceOrderItemAsAdmin>>, TError,{orderId: string;data: BodyType<PlaceOrderItemAsAdminBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiPlaceOrderItemAsAdmin>>,
        TError,
        {orderId: string;data: BodyType<PlaceOrderItemAsAdminBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiPlaceOrderItemAsAdminMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiCancelOrderItemAsAdmin = (
    orderId: MaybeRef<string | undefined | null>,
    orderItemId: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      orderId = unref(orderId);
orderItemId = unref(orderItemId);
      
      return fetchApiInstance<OrderEntity>(
      {url: `/orders/${orderId}/items/${orderItemId}`, method: 'DELETE'
    },
      options);
    }
  


export const getApiCancelOrderItemAsAdminMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiCancelOrderItemAsAdmin>>, TError,{orderId: string;orderItemId: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiCancelOrderItemAsAdmin>>, TError,{orderId: string;orderItemId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiCancelOrderItemAsAdmin>>, {orderId: string;orderItemId: string}> = (props) => {
          const {orderId,orderItemId} = props ?? {};

          return  apiCancelOrderItemAsAdmin(orderId,orderItemId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiCancelOrderItemAsAdminMutationResult = NonNullable<Awaited<ReturnType<typeof apiCancelOrderItemAsAdmin>>>
    
    export type ApiCancelOrderItemAsAdminMutationError = ErrorType<BackendErrorEntity>

    export const useApiCancelOrderItemAsAdmin = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiCancelOrderItemAsAdmin>>, TError,{orderId: string;orderItemId: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiCancelOrderItemAsAdmin>>,
        TError,
        {orderId: string;orderItemId: string},
        TContext
      > => {

      const mutationOptions = getApiCancelOrderItemAsAdminMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiResendOrderEmails = (
    orderId: MaybeRef<string | undefined | null>,
    resendOrderEmailsBodyDto: MaybeRef<ResendOrderEmailsBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      orderId = unref(orderId);
resendOrderEmailsBodyDto = unref(resendOrderEmailsBodyDto);
      
      return fetchApiInstance<ResendOrderEmailsResponseDto>(
      {url: `/orders/${orderId}/resend-emails`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resendOrderEmailsBodyDto
    },
      options);
    }
  


export const getApiResendOrderEmailsMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiResendOrderEmails>>, TError,{orderId: string;data: BodyType<ResendOrderEmailsBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiResendOrderEmails>>, TError,{orderId: string;data: BodyType<ResendOrderEmailsBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiResendOrderEmails>>, {orderId: string;data: BodyType<ResendOrderEmailsBodyDto>}> = (props) => {
          const {orderId,data} = props ?? {};

          return  apiResendOrderEmails(orderId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiResendOrderEmailsMutationResult = NonNullable<Awaited<ReturnType<typeof apiResendOrderEmails>>>
    export type ApiResendOrderEmailsMutationBody = BodyType<ResendOrderEmailsBodyDto>
    export type ApiResendOrderEmailsMutationError = ErrorType<BackendErrorEntity>

    export const useApiResendOrderEmails = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiResendOrderEmails>>, TError,{orderId: string;data: BodyType<ResendOrderEmailsBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiResendOrderEmails>>,
        TError,
        {orderId: string;data: BodyType<ResendOrderEmailsBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiResendOrderEmailsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    